import React, {useEffect, useState, useContext} from "react";
import ReactPlayer from "react-player";
import Navbar from "./Navbar"; // Ensure this import is correct
import "./App.css";
import { useLocation } from "react-router-dom";
import { AppContext } from "./ContextVars"; // #added para #testmode 20/7/25 TG

const HomePage = () => { // #added 28/3/25 TG

    const location = useLocation(); // #added 29/3/25 TG
    const currentVersion = "29.3.25.TG"; // #added 29/3/25 TG
    const [clickCount, setClickCount] = useState(0); // #added #testmode 20/7/25 TG
    const {setTestMode} = useContext(AppContext);

    const handleClick = () => { // #added 28/3/25 TG
        alert("Button click coming soon, thanks for clicking our button!");
    };

    useEffect(() => { // #added 29/3/25 TG
        if (location.hash) {
          const sectionId = location.hash.replace("#", ""); // Remove the #
          const section = document.getElementById(sectionId);
          if (section) {
            section.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [location]);

      useEffect(() => {
        console.log("current version: " + currentVersion);
      }, []);

      const countTestClick = () => {
        setClickCount(clickCount+1);
        if (clickCount >= 7) {
          setTestMode(true);
        }
      }

      //------------------------------------
      // JSX TG
      //------------------------------------

  return (
    <div>
      {/* <Navbar /> */}
      <main>

        {/* Main Welcome Section */}
        <section id="home" className="section">
          <div className="section__content">
            <h2 className="home-subtitle">Welcome to</h2>
            <h1 className="home-title" onClick={countTestClick}>Eleven.fit</h1>
          </div>
        </section>

        {/* #Program Section */}
        <section id="program" className="section">
          <div className="video-container">
            <ReactPlayer
              url="https://www.youtube.com/watch?v=6P7Ngrsplw8"
              playing
              loop
              muted
              controls={false}
              width="100%"
              height="100%"
              className="react-player"
            />
          </div>
          <div className="section__content">
            <div className="program-content">
              <h2 className="program-title width-50 move-left">
                ENJOY OUR HIGH INTENSITY FUNCTIONAL FITNESS PROGRAM
              </h2>
              <div className="program-description max-width-700px move-left">
                Burn calories, build strength, and be fit with our high-intensity workouts
              </div>
              <button className="button-2 move-left margin-top-10" onClick={handleClick}>
                Tell me more
              </button>
            </div>
          </div>
        </section>

        {/* #App */}
        <section id="app" className="section overlay tint-black-50">
          <div className="section__content">
            <div className="gdiv width-80 gap-10px">
              <h2 className="general-title text-align-right move-right text-shadow">
                GET THE ELEVEN.FIT APP
              </h2>
              <div className="general-description text-align-right move-left text-shadow">
                Achieve your consistency goals, track your sessions, and get the best workouts in our app. No installation needed!
              </div>
              <button className="button-2 move-right margin-top-10" onClick={handleClick}>
                Oh my, I want it!
              </button>
            </div>
          </div>
        </section>

        {/* #Who Am I */}
        <section id="who-am-i" className="section">
          <div className="section__content">
            <div className="gdiv width-80 gap-10px">
              <h2 className="general-title text-align-left move-left text-shadow">
                WHO AM I
              </h2>
              <div className="general-description text-align-left move-left text-shadow">
                My name is Oscar, I'm a functional fitness coach since 2016. My goal is to help people be fit for life.
              </div>
              <button className="button-2 move-left margin-top-10" onClick={handleClick}>
                More Info
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomePage;